<template>
  <div class="component-container">
    <div class="search-container">
      <div class="search-by-department">
        <div class="search-by-radio-box">
          <input
            type="radio"
            checked
            name="search_by"
            id="company"
            value=""
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="searchToggle !== '' ? 'label-disable' : ''"
            for="company"
          >
            {{
              $t(
                "project.chart.person_in_charge_manmonth_search_company_search"
              )
            }}
          </label>
        </div>
        <div class="search-by-radio-box">
          <input
            type="radio"
            name="search_by"
            id="department_1"
            value="SOFTWARE_DEVELOPMENT"
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="
              searchToggle !== 'SOFTWARE_DEVELOPMENT' ? 'label-disable' : ''
            "
            for="department_1"
          >{{
              $t(
                "project.chart.person_in_charge_manmonth_search_department_1_search"
              )
            }}</label
          >
        </div>
        <div class="search-by-radio-box">
          <input
            type="radio"
            name="search_by"
            id="department_2"
            value="SOFTWARE_DEVELOPMENT_2"
            @change="setSearchToggle($event)"
          />
          <label
            class="search-label"
            :class="
              searchToggle !== 'SOFTWARE_DEVELOPMENT_2' ? 'label-disable' : ''
            "
            for="department_2"
          >{{
              $t(
                "project.chart.person_in_charge_manmonth_search_department_2_search"
              )
            }}</label
          >
        </div>
      </div>
      <div class="vertical-line"/>
      <div class="search-year">
        <date-picker
          v-model="searchDate"
          format="MM/YYYY"
          placeholder="MM/YYYY"
          type="month"
          value-type="format"
          @change="setDate"
          :clearable="false"
          :editable="false"
        >
          <i slot="icon-calendar">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9997 2.66602H3.99967C2.52692 2.66602 1.33301 3.85992 1.33301 5.33268V11.9993C1.33301 13.4721 2.52692 14.666 3.99967 14.666H11.9997C13.4724 14.666 14.6663 13.4721 14.6663 11.9993V5.33268C14.6663 3.85992 13.4724 2.66602 11.9997 2.66602Z"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.33301 1.33301V3.99967"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.666 1.33301V3.99967"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.33301 6.66602H14.6663"
                stroke="#303C54"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </i>
        </date-picker>
      </div>
    </div>
    <div class="chart-container" @wheel.prevent="rowChart">
      <v-chart
        :option="option"
        autoresize
        style="min-height: 500px; width: 100%"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {BarChart} from "echarts/charts";
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TimelineComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import {mapActions, mapGetters} from "vuex";

use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  BarChart,
]);
const colors = ["#01959E", "#5E495A", "#EA6057"];
const tops = ["Linh NTD", "Hương NT", "Đồng VH", "Tiến PH", "mot", "hai", "ba"];
export default {
  name: "PersonInChargeManmonth",
  components: {
    DatePicker,
    VChart,
  },
  data() {
    return {
      searchToggle: '',
      searchDate: ((new Date().getMonth() + 1) <= 9 ?  ("0" + (new Date().getMonth() + 1)) : (new Date().getMonth() + 1) ) + '/' + new Date().getFullYear(),
      windowWidth: document.documentElement.clientWidth,
      isMobile: false,
      option: {
        barWidth: 40,
        color: colors,
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "cross",
          },
          borderWidth: 0,
          padding: 0,
          backgroundColor: "transparent",
          textStyle: {
            fontFamily: "Helvetica",
            fontSize: 16,
          },
          formatter: (params) => {
            let focusTop = this.personInChargeManmonth.filter(
              (item) => item.id === params.data.id
            )[0];
            let listProject;
            if (params.seriesName === "Maintain") {
              listProject = focusTop.MAINTAIN.detail;
            } else if (params.seriesName === "Spot") {
              listProject = focusTop.SPOT.detail;
            } else {
              listProject = focusTop.LABO.detail;
            }

            let month = this.searchDate.split("/")[0];
            let string = `<div style="width: 215px;white-space: normal">
                          <div style="background: #E0E0E0;font-family: 'Helvetica Neue';font-style: normal;font-weight: 500;font-size: 14px;line-height: 17px;color: #303C54;border-radius: 10px 10px 0 0;height: 39px;display: flex;justify-content:center;align-items: center">
                            ${params.seriesName} - Tháng ${month}
                          </div>
                          <div style="padding: 14px 10px 14px 10px;border: 1px solid #ECECEC;border-radius: 0 0 10px 10px;background: #FFFFFF;">
                            <div style="border: 1px solid #ECECEC;border-radius: 10px;">
                            `;
            listProject.forEach((element, index) => {
              string += `<div style="display: flex;justify-content:space-between">
                                  <div style="padding: 6px 10px 6px 10px; flex: 1; border-right: 1px solid #ECECEC; border-bottom: ${
                index !== listProject.length - 1
                  ? "1px solid #ECECEC"
                  : "none"
              }; font-family: Helvetica Neue; font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px">
                                    ${element.name}
                                  </div>
                                  <div style="display:flex; align-items: center;padding: 6px 10px 6px 10px; flex: 1; border-bottom: ${
                index !== listProject.length - 1
                  ? "1px solid #ECECEC"
                  : "none"
              }; text-align: start; color: #17A896;font-family: Helvetica Neue; font-style: normal;font-weight: 700;font-size: 14px; line-height: 17px">
                                    ${element.total_effort}MM
                                  </div>
                            </div>`;
            });
            string += `</div>
                          </div>
                       </div>`;

            return string;
          },
        },
        grid: {
          right: "0",
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {show: true}
        //   }
        // },
        legend: {
          textStyle: {
            fontFamily: "Helvetica",
            fontSize: 16,
            fontWeight: 400,
          },
          itemGap: 30,
          itemWidth: 20,
          itemHeight: 20,
        },
        dataZoom: {
          type: "inside",
          id: "insideX",
          // start: 20,
          // end: 80,
          disabled: true,
          startValue: 0,
          endValue: 2,
          zoomOnMouseWheel: false,
          moveOnMouseMove: true,
          moveOnMouseWheel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true,
          },
          offset: 10,
          // prettier-ignore
          data: [],
          axisLabel: {
            fontWeight: 500,
            fontSize: 12,
            fontFamily: "Helvetica",
          },
        },
        yAxis: [
          {
            type: "value",
            name: this.$t("project.chart.manmonth_amount"),
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              // lineStyle: {
              //   color: colors[0]
              // }
            },
            axisLabel: {
              formatter: "{value}",
            },
            nameTextStyle: {
              fontSize: 16,
              fontFamily: "Helvetica",
            },
          },
        ],
        series: [
          {
            id: 3,
            name: this.$t(
              "project.chart.person_in_charge_project_type_maintain"
            ),
            type: "bar",
            stack: null,
            data: [],
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
          {
            id: 2,
            name: this.$t("project.chart.person_in_charge_project_type_spot"),
            type: "bar",
            barGap: "0%",
            data: [],
            stack: null,
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
          {
            id: 1,
            name: this.$t("project.chart.person_in_charge_project_type_labo"),
            type: "bar",
            barGap: "0%",
            data: [],
            stack: null,
            label: {
              show: true,
              align: "center",
              fontSize: 14,
              fontWeight: 400,
              fontFamily: "Helvetica",
              color: "#FFFFFF",
              verticalAlign: "top",
              position: "insideTop",
              formatter: (param) => {
                return param.value > 0 ? param.value : '';
              }
            },
            barCategoryGap: "30%",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      personInChargeManmonth: "project/personInChargeManmonth",
    }),
    projectTopOffshore() {
      return this.personInChargeManmonth.map((item) => item.name);
    },
    projectLabo() {
      return this.personInChargeManmonth.map((item) => {
        return {
          value: item.LABO.total_effort,
          id: item.id,
        };
      });
    },
    projectMaintain() {
      return this.personInChargeManmonth.map((item) => {
        return {
          value: item.MAINTAIN.total_effort,
          id: item.id,
        };
      });
    },
    projectSpot() {
      return this.personInChargeManmonth.map((item) => {
        return {
          value: item.SPOT.total_effort,
          id: item.id,
        };
      });
    },
  },
  watch: {
    isMobile() {
      this.option.series.forEach((item) => {
        item.stack = this.isMobile ? "x" : null;
      });
      this.option.dataZoom.endValue = this.isMobile ? this.option.dataZoom.startValue + 1 : this.option.dataZoom.startValue + 2;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    if (this.isMobile) {
      this.option.series.forEach((item) => {
        item.stack = "x";
      });
      this.option.dataZoom.endValue = this.option.dataZoom.startValue + 1;
    } else {
      this.option.series.forEach((item) => {
        item.stack = null;
      });
      this.option.dataZoom.endValue = this.option.dataZoom.startValue + 2;
    }
  },
  async created() {
    await this.setLoading(true);
    let date = this.searchDate.split("/");
    await this.$store.dispatch("project/getPersonInChargeManmonth", {
      division: "",
      month: date[1] + "-" + date[0],
    });
    this.option.xAxis.data = this.projectTopOffshore;
    this.option.series[0].data = this.projectMaintain;
    this.option.series[1].data = this.projectSpot;
    this.option.series[2].data = this.projectLabo;
    await this.setLoading(false);
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    onResize() {
      this.isMobile = document.documentElement.clientWidth < 1421;
    },
    async setSearchToggle(event) {
      await this.setLoading(true);
      this.searchToggle = event.target.value;
      let date = this.searchDate.split("/");
      await this.$store.dispatch("project/getPersonInChargeManmonth", {
        division: this.searchToggle,
        month: date[1] + "-" + date[0],
      });
      this.option.xAxis.data = this.projectTopOffshore;
      this.option.series[0].data = this.projectMaintain;
      this.option.series[1].data = this.projectSpot;
      this.option.series[2].data = this.projectLabo;
      await this.setLoading(false);
    },
    async setDate() {
      await this.setLoading(true);
      let date = this.searchDate.split("/");
      await this.$store.dispatch("project/getPersonInChargeManmonth", {
        division: this.searchToggle,
        month: date[1] + "-" + date[0],
      });
      this.option.xAxis.data = this.projectTopOffshore;
      this.option.series[0].data = this.projectMaintain;
      this.option.series[1].data = this.projectSpot;
      this.option.series[2].data = this.projectLabo;
      await this.setLoading(false);
    },
    rowChart(event) {
      if (event.deltaY > 0) {
        if (this.option.dataZoom.endValue < this.option.xAxis.data.length) {
          this.option.dataZoom.startValue += 1;
          this.option.dataZoom.endValue += 1;
        }
      } else {
        if (this.option.dataZoom.startValue > 0) {
          this.option.dataZoom.startValue -= 1;
          this.option.dataZoom.endValue -= 1;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
label {
  margin-bottom: 0;
}

.chart-container {
  padding-top: 35px;
}

.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-by-department {
  display: flex;
  @media screen and (max-width: 1421px) {
    flex: 1 1 auto;
  }
}

.search-by-radio-box {
  padding-right: 12px;
}

.search-by-radio-box:last-child {
  padding-right: 0;
}

.search-year {
}

.vertical-line {
  border-left: 1px solid #d8d8d8;
  height: 4.5rem;
  margin: 0 14px;
}

.search-label {
  color: #303c54;
  width: 98px;
  border: 1px solid #dadada;
  border-radius: 10px;
  padding: 9px;
  font-size: 14px;
  margin-left: 6px;
  @media screen and (max-width: 1484px) {
    width: 82px;
  }
}

.mx-datepicker {
  width: 150px;
}

.label-disable {
  background-color: #f5f5f5;
}

/deep/ .mx-icon-calendar {
  color: white;
}

</style>
